var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElcashBgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6507 148.913L85.7198 99.2579H54.5946L96.4818 25.6714L89.3071 75.6428H120.432L78.6507 148.913ZM26.0017 149.651L39.4013 126.141C30.1165 114.439 24.9466 99.3634 26.0017 83.2334C28.3229 48.9703 58.0764 23.0358 92.3669 25.3552C93.7385 25.4606 95.1102 25.566 96.3763 25.7769L109.459 2.79427C71.6871 -7.01023 30.7496 9.43604 11.0194 45.0696C-8.49984 80.176 -1.21971 122.873 26.0017 149.651ZM148.603 24.9335L135.837 47.4944C145.755 59.4074 151.347 75.0102 150.291 91.6674C147.97 125.93 118.217 151.865 83.9262 149.546C82.027 149.44 80.2334 149.229 78.4397 148.913L65.2511 172.106C103.023 182.122 144.277 165.676 164.113 129.937C183.527 94.6192 176.141 51.7114 148.603 24.9335Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 87.4795,
    y1: -1.49399,
    x2: 87.4795,
    y2: 173.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2686,
    stopColor: "#F7CE03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#EFBC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A416"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElcashBgLogo);
export default __webpack_public_path__ + "static/media/elcash-bg-logo.3aada91b.svg";
export { ForwardRef as ReactComponent };